import * as React from "react";
import type { SVGProps } from "react";
const SvgEvercopyLogoDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={461}
    height={79}
    fill="none"
    {...props}
  >
    <mask
      id="everycopy-logo-black_svg__a"
      width={49}
      height={29}
      x={0}
      y={39}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M0 39.245h48.375v28.302H0V39.245Z" />
    </mask>
    <g mask="url(#everycopy-logo-black_svg__a)">
      <path
        fill="#FD3C34"
        fillRule="evenodd"
        d="M41.26 56.745-.469 67.775v-7.52c0-4.14 3.198-8.36 7.094-9.406l41.75-11.032v7.521c0 4.136-3.198 8.36-7.115 9.407Z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="everycopy-logo-black_svg__b"
      width={49}
      height={29}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M0 0h48.375v28.578H0V0Z" />
    </mask>
    <g mask="url(#everycopy-logo-black_svg__b)">
      <path
        fill="#FFC2C2"
        fillRule="evenodd"
        d="M41.26 16.933-.469 27.968v-7.526c0-4.136 3.198-8.36 7.094-9.401L48.375.005v7.526c0 4.136-3.198 8.36-7.115 9.402Z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="everycopy-logo-black_svg__c"
      width={49}
      height={30}
      x={0}
      y={19}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M0 19.245h48.375v29.333H0V19.245Z" />
    </mask>
    <g mask="url(#everycopy-logo-black_svg__c)">
      <path
        fill="#FC5D56"
        fillRule="evenodd"
        d="M41.26 36.599-.469 47.65V40.13c0-4.14 3.198-8.36 7.094-9.406l41.75-11.032v7.521c0 4.14-3.198 8.36-7.115 9.386Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#000"
      d="M83.143 32.611H105.1c-.115-2.817-1.104-5.172-2.979-7.062-1.875-1.901-4.558-2.854-8.042-2.854-3.182 0-5.76.994-7.73 2.979-1.957 1.99-3.03 4.302-3.207 6.937Zm23.166 11.667 9 2.854c-1.291 4.099-3.703 7.48-7.229 10.146-3.516 2.666-7.844 4-12.98 4-6.374 0-11.785-2.172-16.228-6.521-4.448-4.344-6.667-10.167-6.667-17.458 0-6.86 2.156-12.49 6.48-16.896 4.317-4.417 9.421-6.625 15.312-6.625 6.859 0 12.213 2.099 16.062 6.292 3.86 4.197 5.792 9.849 5.792 16.958 0 1.89-.094 3.02-.271 3.396H82.872c.125 3.364 1.36 6.145 3.708 8.354 2.36 2.208 5.198 3.312 8.52 3.312 5.751 0 9.485-2.604 11.209-7.812ZM166.497 15.153l-17.563 44.75h-10.666l-18.188-44.75h11.771l11.854 31.979 11.583-31.98h11.209ZM181.74 32.611h21.959c-.115-2.817-1.105-5.172-2.98-7.062-1.875-1.901-4.557-2.854-8.041-2.854-3.183 0-5.761.994-7.729 2.979-1.959 1.99-3.032 4.302-3.209 6.937Zm23.167 11.667 9 2.854c-1.292 4.099-3.703 7.48-7.229 10.146-3.516 2.666-7.844 4-12.979 4-6.375 0-11.787-2.172-16.23-6.521-4.448-4.344-6.666-10.167-6.666-17.458 0-6.86 2.156-12.49 6.479-16.896 4.318-4.417 9.422-6.625 15.312-6.625 6.86 0 12.214 2.099 16.063 6.292 3.859 4.197 5.792 9.849 5.792 16.958 0 1.89-.094 3.02-.271 3.396h-32.709c.125 3.364 1.36 6.145 3.709 8.354 2.359 2.208 5.198 3.312 8.521 3.312 5.75 0 9.484-2.604 11.208-7.812ZM250.846 14.882v10.833a24.508 24.508 0 0 0-3.5-.27c-8.016 0-12.021 4.385-12.021 13.145v21.313h-10.667v-44.75h10.375v7.167c1.042-2.386 2.719-4.271 5.042-5.646 2.333-1.386 4.969-2.084 7.917-2.084.984 0 1.937.1 2.854.292ZM279.055 23.611c-3.432 0-6.343 1.245-8.729 3.73-2.39 2.473-3.583 5.853-3.583 10.145 0 4.35 1.208 7.781 3.625 10.292 2.417 2.516 5.375 3.77 8.875 3.77 3.125 0 5.614-.838 7.479-2.52 1.875-1.693 3.115-3.61 3.729-5.75l9.375 3.396c-1.224 3.99-3.599 7.416-7.125 10.291-3.531 2.875-8.015 4.313-13.458 4.313-6.557 0-12.057-2.26-16.5-6.792-4.448-4.541-6.667-10.208-6.667-17 0-6.86 2.188-12.526 6.563-17 4.385-4.469 9.833-6.708 16.333-6.708 5.568 0 10.109 1.437 13.625 4.312 3.526 2.875 5.813 6.334 6.854 10.375l-9.562 3.5c-.615-2.333-1.792-4.302-3.542-5.916-1.74-1.625-4.167-2.438-7.292-2.438ZM320.079 47.903c2.416 2.541 5.364 3.812 8.854 3.812 3.5 0 6.458-1.25 8.875-3.75 2.427-2.51 3.646-6.005 3.646-10.479 0-4.416-1.219-7.86-3.646-10.333-2.417-2.484-5.375-3.73-8.875-3.73-3.49 0-6.438 1.246-8.854 3.73-2.417 2.474-3.625 5.916-3.625 10.333 0 4.406 1.208 7.875 3.625 10.417Zm8.875-34.125c6.734 0 12.291 2.24 16.666 6.708 4.386 4.474 6.584 10.14 6.584 17 0 6.865-2.198 12.542-6.584 17.042-4.375 4.5-9.932 6.75-16.666 6.75-6.683 0-12.219-2.25-16.604-6.75-4.375-4.5-6.563-10.177-6.563-17.042 0-6.86 2.188-12.526 6.563-17 4.385-4.469 9.921-6.708 16.604-6.708ZM373.055 77.362h-10.563V15.153h10.292v6.063c1.167-2.026 3-3.714 5.5-5.063 2.51-1.344 5.427-2.02 8.75-2.02 6.427 0 11.479 2.197 15.146 6.583 3.677 4.375 5.521 9.968 5.521 16.77 0 6.792-1.933 12.412-5.792 16.855-3.865 4.448-8.948 6.666-15.25 6.666-3.073 0-5.802-.583-8.188-1.75-2.39-1.166-4.198-2.635-5.416-4.416v22.52Zm23.979-39.875c0-4.167-1.104-7.521-3.313-10.063-2.198-2.542-5.099-3.813-8.708-3.813-3.557 0-6.453 1.271-8.687 3.813-2.24 2.542-3.355 5.896-3.355 10.063 0 4.224 1.115 7.624 3.355 10.208 2.234 2.573 5.125 3.854 8.666 3.854 3.552 0 6.448-1.281 8.688-3.854 2.234-2.584 3.354-5.984 3.354-10.209ZM431.597 78.007h-11.396l10.75-23.438-19.125-39.416h12.042l12.875 28.291 12.042-28.291h11.291l-28.479 62.854Z"
    />
  </svg>
);
export default SvgEvercopyLogoDark;
